import { type TFunction } from 'react-i18next';
import { type AuthUser } from '../../common/contexts/auth';
import { type SetContentsFunction } from '../../common/contexts/globalToast';
import {
  deleteIntegrationConnection,
  type IntegrationConnection
} from '../../common/utils/integrations-client/jira/connections';
import { type v2 } from '@deque/billing-service-client';

export type GetDeleteConnectionParams = {
  displayName: string;
  connection: IntegrationConnection | null;
  authUser: AuthUser;
  enterprise: v2.Enterprise;
  setIsProcessing: React.Dispatch<React.SetStateAction<boolean>>;
  setError: React.Dispatch<React.SetStateAction<string | null>>;
  connectionsUpdated: () => void;
  setContents: SetContentsFunction;
  t: TFunction<'translation', undefined>;
};

export const getDeleteConnection = ({
  displayName,
  connection,
  authUser,
  enterprise,
  setIsProcessing,
  setError,
  connectionsUpdated,
  setContents,
  t
}: GetDeleteConnectionParams) => {
  const deleteConnection = async (): Promise<void> => {
    try {
      setIsProcessing(true);

      // Delete connection from a server
      if (connection) {
        await deleteIntegrationConnection({
          enterpriseId: enterprise.id,
          token: authUser.token,
          connectionId: connection.id
        });
      }

      setContents(
        t('Successfully deleted connection to {{integrationType}}', {
          integrationType: displayName
        }),
        'confirmation'
      );

      // Refresh list of connections
      connectionsUpdated();
    } catch (exception) {
      // eslint-disable-next-line no-console
      console.error(exception);

      setError(
        t(
          'There was an error deleting {{ displayName }} connection. Please try again.',
          {
            displayName
          }
        )
      );
    } finally {
      setIsProcessing(false);
    }
  };

  return {
    deleteConnection
  };
};
